import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useImagePreview } from './ImagePreview';
import StoreLogoBadge from './StoreLogoBadge';

function ProductCard({ image, title, subtitle, meta, to, actions, storeLogoUrl, storeName }) {
    const { openPreview } = useImagePreview();

    const handleImageClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPreview(image, title);
    };

    const body = (
        <>
            <Box sx={{ position: 'relative' }}>
                {image ? (
                    <CardMedia
                        component="img"
                        height="260"
                        image={image}
                        alt={title}
                        onClick={handleImageClick}
                        sx={{ objectFit: 'cover', cursor: 'zoom-in' }}
                    />
                ) : (
                    <Box
                        sx={{
                            height: 260,
                            background: 'linear-gradient(135deg, rgba(123,47,247,0.22), rgba(10,10,11,0.08))',
                        }}
                    />
                )}
                <StoreLogoBadge src={storeLogoUrl} alt={storeName} />
            </Box>
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom noWrap title={title}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        {subtitle}
                    </Typography>
                )}
                {meta}
            </CardContent>
        </>
    );

    return (
        <Card
            sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                '&:hover': to
                    ? { transform: 'translateY(-4px)', boxShadow: '0 12px 30px rgba(15, 23, 42, 0.15)' }
                    : undefined,
            }}
        >
            {to ? (
                <CardActionArea
                    component={RouterLink}
                    to={to}
                    sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}
                >
                    {body}
                </CardActionArea>
            ) : (
                body
            )}
            {actions && <CardActions sx={{ px: 2, pb: 2 }}>{actions}</CardActions>}
        </Card>
    );
}

export default ProductCard;
